export default "/images/c380e6e1e9bd145b1c06fcc617cb4916.png";